import React from 'react';
// -*- mode: jsx;-*-
/* eslint-disable react/prop-types */

import { AjaxLink } from '../common/ajaxLink.js';
import FavoriteSearch from './FavoriteSearch.js';

let BreadcrumbControls = props => {
    const crumbs = [];

    if (props.crumbLen > 0) {
        crumbs.push(<FavoriteSearch {...props} key="favorite"/>);

        if (props.crumbLen > 1) {
            crumbs.push(
                <AjaxLink key="clearall"
                    href={props.baseSearchURL} className="clear-all"
                    handleLink={props.callbacks.changeURL}>
                    Clear all
                </AjaxLink>,
            );
        }
    }

    return crumbs;
};
BreadcrumbControls = React.memo(BreadcrumbControls);
export default BreadcrumbControls;
